import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AtaDBService } from '../database/ata-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AtaService extends BaseService{
    override classname: string = 'AtaService';
    public override route: string = 'ata';
    descricaoRevisada?: {id: number; descricao: string};

    assinarOnline(dados: any) {
        return this.http.put(this.url + 'ata/' + dados.id + '/assinatura', dados);
    }
    public override database = Capacitor.isNativePlatform() ? new AtaDBService() : new AtaDBService();

    public override novo() {
        return {
            assinaturas: []
        }
    }
}
